import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

// Components
import { MainButton } from '../../../inputs/buttons/MainButton';
import ModalContainer from '../../containers/ModalContainer';

// Styles — los del modal de confirmación de cierre, tal cual: es la misma
// clase de ventana (una pregunta, dos respuestas).
import {
  Container,
  ContainerText,
  Title,
  ButtonsContainer,
} from '../ConfirmCloseOrderModal/styles';

// Types
import { ModalProps } from './types';

/**
 * Prevención P1 (plan 2026-10-15 § 5). Su.3827 y Su.3898: el cronómetro elegía
 * solo el único recorrido activo aunque fuera del turno de ayer —con el mismo
 * nombre que el de hoy—, y el turno nuevo acababa grabado dentro del viejo.
 * Ahora pregunta antes.
 *
 * Cerrar sin contestar (X, Escape, clic fuera) no elige nada: el cronómetro
 * vuelve a preguntar la próxima vez que se abra.
 */
export const ContinueShiftModal = ({
  onClickClose,
  data,
}: ModalProps): JSX.Element => {
  const { t } = useTranslation(['pages']);
  const theme = useTheme();
  // QA T6: una sola respuesta. Un doble toque no puede contestar dos veces.
  const [answered, setAnswered] = useState(false);
  const answer = (handler?: () => void) => () => {
    if (answered) return;
    setAnswered(true);
    handler?.();
  };

  return (
    <ModalContainer
      width={50}
      fill={theme.colors.black}
      onClickClose={onClickClose}
    >
      <Container data-testid="continue-shift-modal">
        <ContainerText>
          <Title variant="semiBold">
            {t('pages:surveillance.continueShift.question', {
              name: data?.routeName ?? '',
              date: data?.shiftDate ?? '',
            })}
          </Title>
        </ContainerText>
        <ButtonsContainer>
          <MainButton
            variant="secondary"
            text={t('pages:surveillance.continueShift.continue')}
            onClick={answer(data?.onContinue)}
            disabled={answered}
          />
          <MainButton
            text={t('pages:surveillance.continueShift.startNew')}
            onClick={answer(data?.onStartNew)}
            disabled={answered}
          />
        </ButtonsContainer>
      </Container>
    </ModalContainer>
  );
};

export default ContinueShiftModal;
